<script setup>
import sansFrais4x from "@/assets/images/4x-sans-frais.png";
import sansFrais3x from "@/assets/images/3x-sans-frais.png";
import carteAurore from "@/assets/images/carte-aurore.png";
import carteCora from "@/assets/images/cora-mastercard.png";
import carteBleue from "@/assets/images/carte-bleue.png";
import cartePass from "@/assets/images/carte-pass-carrefour.png";
import carteMastercard from "@/assets/images/carte-mastercard.png";
import carteVisa from "@/assets/images/carte-visa.png";
import carteCb from "@/assets/images/carte-cb.png";
import LazyImage from "@/components/atoms/lazy-image";
</script>
<script>
export default {
  name: "PaymentMethodCards",
  components: {
    LazyImage
  },
  props: {
    paymentMethod: {
      type: String,
      required: false,
      default: "cb"
    },
    isFidCarrefour: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <div>
    <template v-if="paymentMethod === 'cb'">
      <LazyImage
        :src="carteCb"
        class="u-mr-xs"
        alt="cb"
        v-bind="removeClassAndStyleFromAttrs($attrs)"
      />
      <LazyImage
        :src="carteVisa"
        class="u-mr-xs"
        alt="Mastercard"
        v-bind="removeClassAndStyleFromAttrs($attrs)"
      />
      <LazyImage
        :src="carteMastercard"
        class="u-mr-xs"
        alt="Mastercard"
        v-bind="removeClassAndStyleFromAttrs($attrs)"
      />
      <LazyImage
        :src="carteBleue"
        class="u-mr-xs"
        alt="Mastercard"
        v-bind="removeClassAndStyleFromAttrs($attrs)"
      />
      <LazyImage
        v-if="isFidCarrefour"
        :src="cartePass"
        class="u-mr-xs"
        alt="Carte Pass"
        v-bind="removeClassAndStyleFromAttrs($attrs)"
      />
    </template>
    <template v-if="paymentMethod === 'cora'">
      <LazyImage
        :src="carteCora"
        class="u-mr-xs"
        alt="Carte Cora"
        v-bind="removeClassAndStyleFromAttrs($attrs)"
      />
    </template>
    <template v-if="paymentMethod === 'caurore'">
      <LazyImage
        :src="carteAurore"
        class="u-mr-xs"
        alt="carte aurore"
      />
    </template>
    <template v-if="paymentMethod === '3FCB'">
      <LazyImage
        :src="sansFrais3x"
        width="60"
        class="u-mr-xs"
        alt="Carte Bancaire en 3 fois sans frais"
      />
    </template>
    <template v-if="paymentMethod === '4FCB'">
      <LazyImage
        :src="sansFrais4x"
        width="60"
        class="u-mr-xs"
        alt="Carte Bancaire en 4 fois sans frais"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped></style>
